import { render, staticRenderFns } from "./Home.bundle-ids.vue?vue&type=template&id=68192b68&scoped=true&"
import script from "./Home.bundle-ids.vue?vue&type=script&lang=js&"
export * from "./Home.bundle-ids.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68192b68",
  null
  
)

export default component.exports